export default __webpack_public_path__ + "static/media/paint3d.54afdba5.jpg";